"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function RegionalMarketInsights() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: panelRef,
    isVisible: panelVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const routes = [{
    dest: "NORTH AMERICA",
    miles: "OTA",
    freq: "DAILY"
  }, {
    dest: "EUROPEAN UNION",
    miles: "GDS",
    freq: "WEEKLY"
  }, {
    dest: "ASIA PACIFIC",
    miles: "OTA",
    freq: "ON DEMAND"
  }, {
    dest: "MIDDLE EAST",
    miles: "GDS",
    freq: "WEEKLY"
  }, {
    dest: "LATIN AMERICA",
    miles: "OTA",
    freq: "MONTHLY"
  }, {
    dest: "AFRICA",
    miles: "GDS",
    freq: "ON DEMAND"
  }, {
    dest: "INDIA",
    miles: "OTA",
    freq: "DAILY"
  }, {
    dest: "UK",
    miles: "GDS",
    freq: "WEEKLY"
  }, {
    dest: "SOUTHEAST ASIA",
    miles: "OTA",
    freq: "WEEKLY"
  }, {
    dest: "SCANDINAVIA",
    miles: "GDS",
    freq: "MONTHLY"
  }, {
    dest: "OCEANIA",
    miles: "OTA",
    freq: "ON DEMAND"
  }, {
    dest: "CARIBBEAN",
    miles: "GDS",
    freq: "MONTHLY"
  }, {
    dest: "CENTRAL ASIA",
    miles: "OTA",
    freq: "ON DEMAND"
  }, {
    dest: "EAST ASIA",
    miles: "GDS",
    freq: "WEEKLY"
  }, {
    dest: "MEDITERRANEAN",
    miles: "OTA",
    freq: "WEEKLY"
  }, {
    dest: "BALTIC STATES",
    miles: "GDS",
    freq: "MONTHLY"
  }];
  const stats = [{
    label: "AVG AUDIT TIME",
    value: "24 HRS"
  }, {
    label: "WEEKLY OPTIMIZATIONS",
    value: "45"
  }, {
    label: "ACTIVE PROPERTIES",
    value: "120+"
  }];
  return <section data-section-id="1667" id="regionalmarketinsights" className="relative bg-background text-foreground overflow-hidden py-24 md:py-32">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute right-4 md:right-12 top-1/2 -translate-y-1/2 select-none font-serif font-light leading-none text-foreground opacity-[0.03]" style={{
      fontSize: "28vw"
    }}>
        02
      </div>

      <div className="relative mx-auto w-full max-w-[1440px] px-6 md:px-12 lg:px-[88px]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div ref={headerRef} className={`lg:col-span-8 transition-all duration-[800ms] ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
        }}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="font-default text-[0.75rem] uppercase tracking-[0.18em] text-secondary">
                § 02 / MARKET REACH — GLOBAL HOSPITALITY
              </span>
            </div>

            {}
            <div className="flex items-center mb-10" aria-hidden="true">
              <span className="block h-px w-20 bg-secondary" />
              <span className="block h-1 w-1 bg-secondary ml-0" />
            </div>

            {}
            <h2 className="font-default font-bold text-foreground leading-[1.0] tracking-tight mb-8" style={{
            fontSize: "clamp(2.25rem, 5.4vw, 4.75rem)",
            letterSpacing: "-0.02em"
          }}>
              Global Revenue{" "}
              <span className="italic text-secondary">Insights</span>
            </h2>

            {}
            <p className="font-default text-foreground/85 max-w-2xl mb-14 leading-relaxed" style={{
            fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)"
          }}>
              Data-driven revenue management across global markets. We optimize OTA performance and GDS visibility for hotels worldwide.
            </p>

            {}
            <div className="hidden md:grid grid-cols-12 gap-4 pb-3 border-b border-border mb-2">
              <div className="col-span-7 font-default text-[0.7rem] uppercase tracking-[0.18em] text-foreground/55">
                Region
              </div>
              <div className="col-span-3 font-default text-[0.7rem] uppercase tracking-[0.18em] text-foreground/55">
                Channel
              </div>
              <div className="col-span-2 font-default text-[0.7rem] uppercase tracking-[0.18em] text-foreground/55 text-right">
                Frequency
              </div>
            </div>

            {}
            <div className="flex flex-col">
              {routes.map((route, i) => <div data-index={i} key={i} className="group relative grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-4 py-4 border-b border-border transition-colors duration-300 hover:bg-accent cursor-default">
                  <div className="md:col-span-7 flex items-center gap-3">
                    <span className="font-default text-[0.7rem] text-foreground/40 uppercase tracking-[0.15em]">
                      REV →
                    </span>
                    <span className="font-default text-foreground text-base md:text-[0.95rem] tracking-wide">
                      {route.dest}
                    </span>
                  </div>
                  <div className="md:col-span-3 flex items-center">
                    <span className="font-default text-sm text-secondary tracking-[0.08em] transition-colors duration-300 group-hover:brightness-125">
                      {route.miles}
                    </span>
                  </div>
                  <div className="md:col-span-2 flex items-center md:justify-end">
                    <span className="font-default text-[0.7rem] uppercase tracking-[0.16em] text-foreground/55">
                      {route.freq}
                    </span>
                  </div>

                  {}
                  <div aria-hidden="true" className="pointer-events-none absolute left-0 bottom-0 flex items-center">
                    <span className="block h-px bg-secondary w-0 group-hover:w-24 transition-all duration-[250ms] ease-out" />
                    <span className="block h-1 w-1 bg-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-[250ms]" />
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div ref={panelRef} className={`lg:col-span-4 transition-all duration-[800ms] ease-out ${panelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)",
          transitionDelay: "120ms"
        }}>
            <div className="lg:sticky lg:top-28 flex flex-col gap-10">
              {}
              <div className="relative border border-border p-8 transition-colors duration-300 hover:border-secondary" style={{
              backgroundColor: "var(--card)"
            }}>
                {}
                <span aria-hidden="true" className="absolute top-2 left-2 w-3 h-3 pointer-events-none">
                  <span className="absolute top-1/2 left-0 h-px w-3 bg-secondary" />
                  <span className="absolute left-1/2 top-0 w-px h-3 bg-secondary" />
                </span>
                <span aria-hidden="true" className="absolute top-2 right-2 w-3 h-3 pointer-events-none">
                  <span className="absolute top-1/2 left-0 h-px w-3 bg-secondary" />
                  <span className="absolute left-1/2 top-0 w-px h-3 bg-secondary" />
                </span>
                <span aria-hidden="true" className="absolute bottom-2 left-2 w-3 h-3 pointer-events-none">
                  <span className="absolute top-1/2 left-0 h-px w-3 bg-secondary" />
                  <span className="absolute left-1/2 top-0 w-px h-3 bg-secondary" />
                </span>
                <span aria-hidden="true" className="absolute bottom-2 right-2 w-3 h-3 pointer-events-none">
                  <span className="absolute top-1/2 left-0 h-px w-3 bg-secondary" />
                  <span className="absolute left-1/2 top-0 w-px h-3 bg-secondary" />
                </span>

                <div className="font-default text-[0.7rem] uppercase tracking-[0.18em] text-secondary mb-6">
                  § 02.A / CONSULTATION
                </div>

                <h3 className="font-default font-bold text-foreground mb-4 leading-[1.15]" style={{
                fontSize: "clamp(1.5rem, 2.6vw, 2.25rem)",
                letterSpacing: "-0.015em"
              }}>
                  Need a <span className="italic text-secondary">Revenue Audit?</span>
                </h3>

                <p className="font-default text-foreground/65 text-[0.9375rem] leading-[1.65] mb-8">
                  Sunil Singh provides expert revenue audits for properties worldwide. Let's maximize your direct bookings.
                </p>

                <Button asChild className="btn-primary w-full h-auto rounded-md px-7 py-4 font-default text-[0.78rem] uppercase tracking-[0.16em] transition-all duration-300">
                  <Link to="/ContactPage">
                    Book a Consultation
                  </Link>
                </Button>
              </div>

              {}
              <div className="flex flex-col">
                <div className="flex items-center mb-6" aria-hidden="true">
                  <span className="block h-px w-12 bg-secondary" />
                  <span className="block h-1 w-1 bg-secondary" />
                </div>
                <div className="flex flex-col gap-6">
                  {stats.map((stat, i) => <div data-index={i} key={i} className="flex items-baseline justify-between border-b border-border pb-4">
                      <span className="font-default text-[0.72rem] uppercase tracking-[0.18em] text-foreground/55">
                        {stat.label}
                      </span>
                      <span className="font-default text-base md:text-lg text-secondary tracking-[0.08em]">
                        / {stat.value}
                      </span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}